import * as types from "../constants";

const initialState = {
  isLoading: true,
  error: null,
  items: 0,
};

export default function disseminationDocumentModificationAddRuledReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case types.GET_DISSEMINATION_DOCUMENT_MODIFICATION_ADD_RULE_INIT:
      return { ...state, error: null, isLoading: true };

    case types.GET_DISSEMINATION_DOCUMENT_MODIFICATION_ADD_RULE_SUCCESS:
      return { ...state, isLoading: false, items: action.data.data };

    case types.GET_DISSEMINATION_DOCUMENT_MODIFICATION_ADD_RULE_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.notification.system_message,
      };

    default:
      return state;
  }
}
